const ChevronRight = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M5.80315 12.8632C5.54362 12.6037 5.54346 12.1829 5.8028 11.9232L9.72 8.00005L5.8028 4.07689C5.54346 3.81716 5.54362 3.39643 5.80315 3.13689C6.06282 2.87722 6.48384 2.87722 6.74351 3.13689L11.1353 7.52864C11.3956 7.78899 11.3956 8.2111 11.1353 8.47145L6.74351 12.8632C6.48384 13.1229 6.06283 13.1229 5.80315 12.8632Z"
			fill="currentColor"
		/>
	</svg>
);

export default ChevronRight;
